import(/* webpackMode: "eager", webpackExports: ["ProfessionalServicesLandingClient"] */ "/workspace/src/components/profile/ProfessionalServicesLandingClient.tsx");
